module.exports = __webpack_public_path__ + "img/incomeOrange.c9347226.png";